import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Format number as Brazilian Real currency
 */
export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
}

/**
 * Format date to Brazilian format
 */
export function formatDate(date: string | Date): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return new Intl.DateTimeFormat('pt-BR').format(d);
}

/**
 * Calculate coverage percentage badge variant
 */
export function getCoverageVariant(coverage: number): "default" | "secondary" | "destructive" | "outline" {
  if (coverage >= 90) return "default";
  if (coverage >= 70) return "secondary";
  if (coverage >= 50) return "outline";
  return "destructive";
}

/**
 * Calculate coverage label
 */
export function getCoverageLabel(coverage: number): string {
  if (coverage >= 90) return "Excelente";
  if (coverage >= 70) return "Bom";
  if (coverage >= 50) return "Regular";
  return "Baixo";
}

/**
 * Get user initials from name
 */
export function getInitials(name: string): string {
  return name
    .split(' ')
    .map(part => part[0])
    .join('')
    .substring(0, 2)
    .toUpperCase();
}

/**
 * Format file size to human readable format
 */
export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
}

/**
 * Check if file is an image
 */
export function isImageFile(filename: string): boolean {
  return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filename);
}

/**
 * Check if file is a PDF
 */
export function isPdfFile(filename: string): boolean {
  return /\.pdf$/i.test(filename);
}
